/* eslint-disable prettier/prettier */
export default [
  '<table class="calendar-table">',
    '<thead>',
      '<tr>',
        '<td class="calendar-prev">',
          '<a class="btn btn--outline btn--icon" href="#">',
            '<span class="svgIcon svgIcon--stroked"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m16 20-8-8 8-8" /></svg></span>',
            '<span class="txtAssistive">&#8592;</span>',
          '</a>',
        '</td>',
        '<td colspan="5" class="calendar-title"><span class="calendar-month"></span> <span class="calendar-year"></span></td>',
        '<td class="calendar-next">',
          '<a class="btn btn--outline btn--icon" href="#">',
            '<span class="svgIcon svgIcon--stroked"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m8 20 8-8-8-8" /></svg></span>',
            '<span class="txtAssistive">&#8594;</span>',
          '</a>',
        '</td>',
      '</tr>',
    '</thead>',
    '<tbody></tbody>',
  '</table>'
].join('');
